var api_prefix = '';

export const API_ENDPOINTS = {

  auth: {
    login: `${api_prefix}/auth/login`,
    resetPassword: `${api_prefix}/auth/ask-for-password-reset`,
    updateInfo: useId => `${api_prefix}/users/myself/${useId}`,
  },
  project: {
    maintenanceMode: `${api_prefix}/customer/maintenance-mode`,
    pwaVersion: `${api_prefix}/pwaversion`,
    concreteTypes: `${api_prefix}/server_info`,
    psiConcreteTypes: `${api_prefix}/psi_server_info`,
    ClientSensor: `${api_prefix}/device/getclientsensors`,
    ClientBananas: `${api_prefix}/device/getclientbananas`,
    projects: `${api_prefix}/projects`,
    projectspwa: `${api_prefix}/project/pwaprojects`,
    projectGraph: projectId => `${api_prefix}/greenvibe/project/${projectId}/graph`,
    projectDetails: projectId => `${api_prefix}/greenvibe/project/${projectId}/dashboard`,
    markPourAsDone: (projectId: string, pourId: number) =>
      `${api_prefix}/pour/${projectId}/pour/${pourId}/finish`,
    pourDetails: pourId => `${api_prefix}/pour/pourdetails/${pourId}`,
    createPour: `${api_prefix}/pour`,
    updatePour: pourId => `${api_prefix}/pour/${pourId}`,
    pourGaugeDetails: (pourId: string) => `${api_prefix}/pour/pourgagedetails/${pourId}`,
    projectPours: (projectId: string) =>
      `${api_prefix}/project/${projectId}/pwagagesdashboard`,
    pourSensors: (pourId: string, isFinished: boolean) =>
      `${api_prefix}/device/getpoursensors/${pourId}`,
    deleteSensor: (pourId: string, sensorId: string) =>
      `${api_prefix}/device/${pourId}/sensor/${sensorId}`,
    toggleEnableSensor: (pourId: string, sensorId: string) => `${api_prefix}/device/toggleEnableSensor/${pourId}/${sensorId}`,
    geteditsensordetails: (pourId: number,sensorId: string) => `${api_prefix}/device/editsensordetails/${pourId}/${sensorId}`,
    sensorDetails: (pourId: number,sensorId: string) => `${api_prefix}/device/sensor-detail/${pourId}/${sensorId}`,
    sensorIdFromQr: `${api_prefix}/device/getsensoridfromqr`,
    bananaIdFromQr: `${api_prefix}/device/getbananaidfromqr`,
    hubIdFromQr: `${api_prefix}/hub/gethubidfromqr`,
    hubImageUpload: hubId => `${api_prefix}/hub/uploadimage/${hubId}`,

    checkHubLifeSign: (hubId: string) => `${api_prefix}/hub/lifesign/${hubId}`,
    checkSensorLifeSign: (sensorId: string) => `${api_prefix}/device/sensor/lifesign/${sensorId}`,
    addSensor: (sensorId: string) =>
      `${api_prefix}/device/sensor/${sensorId}/assign`,
    switchDevice: (bananaId: string, newDevice: string) => `${api_prefix}/device/switchdevice/${bananaId}/${newDevice}`,
    addHub: (hubId: string) => `${api_prefix}/hub/${hubId}/assign`,
    updateSensor: (sensorId: string) => `${api_prefix}/device/editsensor/${sensorId}`,
    technicalScreenData: (projectId: number) => `${api_prefix}/project/technicalscreen/${projectId}`,
    deleteHub: (hubId: string) => `${api_prefix}/hub/${hubId}`,
    editHub: (hubId: string) => `${api_prefix}/hub/editHub/${hubId}`,
    getConcreteMix: (projectId: number) => `${api_prefix}/project/concretemix/${projectId}`,
  },
  maturity: {
    concretes: (customerId: number) => `${api_prefix}/maturity/concrete/${customerId}`,
    addConcrete: `${api_prefix}/maturity/add-concrete`,
    addConcretePress: `${api_prefix}/maturity/add-concrete/bath-press`,
    calcMaturityParams: `${api_prefix}/maturity/calc-maturity-params`,
  },
  customers: {
    getCustomers: `${api_prefix}/customer/customers`,
  },
};
